import React,{ Component } from 'react';

import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Nav,
  NavItem,
  NavLink,
  FormText
} from 'reactstrap';

import CampaignAgencyForm from './CampaignAgencyForm';
import CampaignNameForm from './CampaignNameForm';
import CampaignBudgetForm from './CampaignBudgetForm';
import CampaignStartDateForm from './CampaignStartDateForm';
import ExpandedStartDateTitle from './ExpandedStartDateTitle';
import CampaignBrandForm from './CampaignBrandForm';
import CampaignDCMForm from './CampaignDCMForm';
import CampaignCoverForm from './CampaignCoverForm';
import CampaignChooseForm from './CampaignChooseForm';
import EngagementTitle from './EngagementTitle';
import CampaignThisOrThatForm from './CampaignThisOrThatForm';
import CampaignQAForm from './CampaignQAForm';
import CampaignRatableForm from './CampaignRatableForm';
import CampaignPuzzleForm from './CampaignPuzzleForm'
import CampaignConclusionForm from './CampaignConclusionForm';
import CampaignOverview from './CampaignOverview';
import CreateEngagementButtons from './CreateEngagementButtons';

import CollapsingSection from '../../../shared/components/CollapsingSection';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import PhonePreview from '../../../shared/components/PhonePreview';
import Pills from '../../../shared/components/Pills';
import ProgressEllipses from '../../../shared/components/ProgressEllipses';
import ScrollWatcher from '../../../shared/components/ScrollWatcher';
import TutorialLoadingScreen from '../../../shared/components/TutorialLoadingScreen';

import ChooseEngagementSVG from '../../../shared/assets/engagement-choose.svg';
import ThisOrThatEngagementSVG from '../../../shared/assets/engagement-this-that.svg';
import VideoEngagementSVG from '../../../shared/assets/engagement-video.svg';
import QAEngagementSVG from '../../../shared/assets/engagement-qa.svg';
import PuzzleEngagementSVG from '../../../shared/assets/engagement-puzzle.svg';

import Placeholder1x1 from '../../../shared/assets/image-1x1.png';
import Placeholder4x3 from '../../../shared/assets/image-4x3.png';

import {
  formatDateRange,
  recursivelyLoadAllPages,
  cutOffLongTextIfNeeded,
  getWindowHeight,
  formatIncompleteEngagements,
  humanReadableList,
  delayPromiseChain,
  engagementOrDefaults,
  isEngagementValid,
  isCoverValid,
  isConclusionValid
} from '../../../shared/utils';

import find from 'lodash/find';
import omit from 'lodash/omit';
import values from 'lodash/values';
import CampaignPriorityForm from "./CampaignPriorityForm";
import isEmptyObject from "lodash/isEmpty";
import CampaignProgramForm from "./CampaignProgramForm";
import * as moment from "moment";

const AGENCY_SECTION = '__AGENCY__',
  DCM_SECTION = '__DCM__',
  NAME_SECTION = '__NAME__',
  BUDGET_SECTION = '__BUDGET__',
  START_DATE_SECTION = '__START_DATE__',
  BRAND_SECTION = '__BRAND__',
  PRIORITY_SECTION = '__PRIORITY__',
    PROGRAM_SECTION = '__PROGRAM__',
  COVER_SECTION = '__COVER_SECTION__',
  CONCLUSION_SECTION = '__CONCLUSION_SECTION__';

const CREATE_NEW_AGENCY_OPTION = '__CREATE_NEW_AGENCY_OPTION__',
  CREATE_NEW_BRAND_OPTION = '__CREATE_NEW_BRAND_OPTION__';

const CHOOSE_ENGAGEMENT_TYPE = 'choose',
  THIS_OR_THAT_ENGAGEMENT_TYPE = 'this_or_that',
  RATABLE_ENGAGEMENT_TYPE = 'ratable',
  QA_ENGAGEMENT_TYPE = 'qa',
  PUZZLE_ENGAGEMENT_TYPE = 'puzzle';

const FEED_PREVIEW_ID = '__FEED__',
  CONCLUSION_PREVIEW_ID = '__CONCLUSION__';

const NAVBAR_HEIGHT = 72;

const MINIMUM_NUMBER_OF_ENGAGEMENTS = 1;

const MAXIMUM_PREVIEW_HEIGHT = 600;

const CAMPAIGN_UPDATE_DELAY = 3000;

class GuidedCampaignCreation extends Component {
  constructor(props){
    super(props);

    this.state = {
      activeSection:null,
      activePreviewEngagementId:'__FEED__',
      isLoading:true,
      isCreatingEngagement:false,
      previewIsFixed:false,
      brandIsValid:false,
      showQAAnswer:false
    };
  }

  componentWillMount(){
    const {activeBrand, activeCampaign, allowingBrandEditingInline, programs} = this.props
    if(!allowingBrandEditingInline){
      this.setState({brandIsValid:true});
    } else if(activeBrand && activeBrand.primaryColor && activeBrand.logoURL){
      this.setState({brandIsValid:true});
    }
  }

  componentDidMount(){
    const loadingPromises = [];

    if (values(this.props.tagVendors).length === 0) {
      loadingPromises.push(this.props.loadTagVendors())
    }

    // if(!this.props.isCreate){
    //   loadingPromises.push(this.props.loadEngagementsForCampaign(this.props.campaignId));
    //   loadingPromises.push(this.props.loadCampaign(this.props.campaignId));
    // }

    if(this.props.showSuperadminFeatures){
      loadingPromises.push(this.props.loadAgencies());
      loadingPromises.push(recursivelyLoadAllPages(this.props.loadBrands,1000));
    }

    if(this.props.isCreate){
      if(this.props.isActiveUserProvider){
        this.setState({activeSection:AGENCY_SECTION});
      } else {
        this.setState({activeSection:NAME_SECTION});
      }
    } else {
      loadingPromises.push(this.props.loadEngagementsForCampaign(this.props.campaignId));
      loadingPromises.push(this.props.loadCampaign(this.props.campaignId));
    }

    Promise.all(loadingPromises)
      .then(() => {
        if(!this.props.isCreate && this.props.activeCampaign.agencyId){
          return this.props.loadAccountHistory(this.props.activeCampaign.agencyId)
              .then(() => this.props.loadProgramsForAgency(this.props.activeCampaign.agencyId))
              .then((data) => {
                const programs = data.instances
                const {activeCampaign} = this.props
                this.setState({activeProgram: activeCampaign && activeCampaign.programId ? programs.filter((c) => c.id === activeCampaign.programId).shift() : null});
                this.validateProgramDates(activeCampaign, this.props.programs.filter((c) => c.id === activeCampaign.programId).shift())
                return Promise.resolve();
              });
        } else {
          return Promise.resolve();
        }
      })
      .then(() => this.setState({isLoading:false}))
      .catch((err) => this.setState({error:err}));

    //TODO FIND A DECLARATIVE WAY OF DOING THIS
    window.scrollTo(0,0);
  }

  handleCampaignChange(data){
    if(this.props.isCreate){
      if(this.props.agencyId && !this.props.activeAgency.id){
        data.agencyId = this.props.agencyId
      };

      if(this.props.activeAgency.defaultPaymentMethodId && !this.props.activeCampaign.paymentMethodId){
        data.paymentMethodId = this.props.activeAgency.defaultPaymentMethodId;
      }

      return this.props.createCampaign(data)
        .then((res) => {
          //TODO DO THIS WITH REAL URL
          const campaignId = res.instance.id,
            currentURL = this.props.match.url;

          this.props.history.push(`${currentURL.slice(0,-4)}/${campaignId}${this.props.location.search}`);
        })
        .catch((err) => this.setState({error:err}));

    } else {
      return this.props.updateCampaign(this.props.campaignId,data);
    }
  }

  handleAgencySubmit(data){
    const activeCampaign = this.props.activeCampaign;

    if(!activeCampaign.name || activeCampaign.name.length === 0){
      this.setState({activeSection:NAME_SECTION});
    } else {
      this.setState({activeSection:null});
    }

    if(data.agencyId === CREATE_NEW_AGENCY_OPTION){
      return this.props.createAgency({
        name:data.agencyName,
        defaultRevenueSplit:parseFloat(data.defaultRevenueSplit),
        ratableDefaultCost:parseFloat(data.ratableDefaultCost),
        thisOrThatDefaultCost:parseFloat(data.thisOrThatDefaultCost),
        chooseDefaultCost:parseFloat(data.chooseDefaultCost)
      })
        .then((res) => {
          const agencyId = res.instance.id;

          return this.handleCampaignChange({agencyId:agencyId})
            .then(() => this.props.loadAccountHistory(agencyId))
        })
        .catch((err) => this.setState({error:err}));

    } else {
      return this.handleCampaignChange({agencyId:data.agencyId})
        .then(() => this.props.loadAccountHistory(data.agencyId))
          .then(() => this.props.loadProgramsForAgency(data.agencyId));
    }
  }

  handleNameSubmit(data){
    const activeCampaign = this.props.activeCampaign;

    if(!activeCampaign.lifetimeBudget || activeCampaign.lifetimeBudget < 500){
      this.setState({activeSection:BUDGET_SECTION});
    } else {
      this.setState({activeSection:null});
    }

    return this.handleCampaignChange(data);
  }

  handleBudgetSubmit(data){
    const activeCampaign = this.props.activeCampaign;

    this.handleCampaignChange(data);
    if(!activeCampaign.launchDate){
      this.setState({activeSection:START_DATE_SECTION});
    } else {
      this.setState({activeSection:null});
    }
  }

  handleDateSubmit(data){
    const activeCampaign = this.props.activeCampaign;
    this.handleCampaignChange(data);
    this.validateProgramDates(data, this.state.activeProgram)

    if((!activeCampaign.brandId || activeCampaign.brandId.length === 0) && activeCampaign.agencyId){
      this.setState({activeSection:BRAND_SECTION});
    } else {
      this.setState({activeSection:null});
    }
  }

  handlePrioritySubmit(data){
    this.handleCampaignChange({ priority: data.priority});
    this.setState({activeSection:null});
  }

  handleProgramSubmit(data){
    this.handleCampaignChange({ programId: data.programId});
    this.validateProgramDates(this.props.activeCampaign, data.activeProgram)
    this.setState({activeSection:null, activeProgram: data.activeProgram});
  }

  validateProgramDates(activeCampaign, activeProgram){
    if(activeCampaign && activeProgram) {
      if (activeProgram && activeCampaign && ( !activeCampaign.launchDate || !activeCampaign.endDate ||
          activeProgram.startDate && activeProgram.endDate && (activeCampaign.launchDate < activeProgram.startDate ||  activeCampaign.endDate > activeProgram.endDate)
      )){
        this.setState({isProgramValid: false});
        return
      }
    }
    this.setState({isProgramValid:true});
  }

  handleBrandSubmit(data){
    const activeCampaign = this.props.activeCampaign;

    this.setState({
      activeSection:COVER_SECTION,
      brandIsValid:true
    });

    if(this.props.allowingBrandEditingInline && (activeCampaign.companyId || '').length > 0){
      //EXISTING CAMPAIGN BEING UPDATED

      return this.props.updateBrand(activeCampaign.companyId,{
        name:data.brandName,
        logoFileName:data.brandLogo.fileName,
        logoId:data.brandLogo.id,
        logoURL:data.brandLogo.large,
        logoThumbnailURL:data.brandLogo.thumbnail,
        primaryColor:data.brandColor,
        agencyId:activeCampaign.agencyId
      })
        .then((res) => this.props.loadCampaign(activeCampaign.id))
        .catch((err) => this.setState({error:err}));

    } else if(data.companyId === CREATE_NEW_BRAND_OPTION){
      //NEW BRAND BEING CREATED

      return this.props.createBrand({
        isBrand:true,
        active:true,
        name:data.brandName,
        primaryColor:data.brandColor,
        logoFileName:data.brandLogo.fileName,
        logoId:data.brandLogo.id,
        logoURL:data.brandLogo.large,
        logoThumbnailURL:data.brandLogo.thumbnail,
        agencyId:activeCampaign.agencyId
      })
        .then((res) => {
          return this.handleCampaignChange({companyId:res.instance.id})
            .then(() => delayPromiseChain(CAMPAIGN_UPDATE_DELAY))
            .then(() => this.props.loadCampaign(activeCampaign.id))
            .catch((err) => this.setState({error:err}));

        })
        .catch((err) => this.setState({error:err}));
    } else {
      //NEW BRAND BEING SELECTED FROM THE DROPDOWN

      return this.handleCampaignChange({companyId:data.companyId})
        .then(() => delayPromiseChain(CAMPAIGN_UPDATE_DELAY))
        .then(() => this.props.loadCampaign(activeCampaign.id))
        .catch((err) => this.setState({error:err}));
    }
  }

  handleCoverSubmit(data){
    const conclusionTags = (this.props.activeCampaign.tags || []).filter((t) => t.type === 'conclusion'),
      feedTags = data.tags || [];

    this.handleCampaignChange({
      feedText:data.feedText || '',
      feedImageURL:data.feedImageURL,
      feedImageFileName:data.feedImageFileName
    });

    this.adjustAndSyncTags(this.props.syncCampaignDCMTags, this.props.campaignId, conclusionTags.concat(feedTags))

    this.setState({activeSection:null});
  }

  handleAddEngagementClick(kind){
    const { activeCampaign, nextOrdinal, createEngagement } = this.props;

    this.setState({isCreatingEngagement:true});

    createEngagement({
      kind:kind,
      agencyId:activeCampaign.agencyId,
      campaignId:activeCampaign.id,
      companyId:activeCampaign.companyId,
      text:'',
      ordinal:nextOrdinal,
      options:[],
      firstImageTitle:'',
      secondImageTitle:'',
      correctAnswerText:''
    })
      .then((res) => this.setState({
        isCreatingEngagement:false,
        activeSection:res.instance.id,
        activePreviewEngagementId:res.instance.id
      }))
      .catch((err) => this.setState({error:err}));
  }

  handleDemoteClick(index){
    const engagements = this.props.activeEngagements;

    if(index === engagements.length - 1) return;

    this.props.updateEngagementSortOrder([
      {
        id:engagements[index].id,
        ordinal:engagements[index + 1].ordinal,
        campaignId:engagements[index].campaignId
      },
      {
        id:engagements[index + 1].id,
        ordinal:engagements[index].ordinal,
        campaignId:engagements[index + 1].campaignId
      }
    ])
      .catch((err) => this.setState({error:err}));
  }

  handlePromoteClick(index){
    const engagements = this.props.activeEngagements;

    if(index === 0) return;

    this.props.updateEngagementSortOrder([
      {
        id:engagements[index].id,
        ordinal:engagements[index - 1].ordinal,
        campaignId:engagements[index].campaignId
      },
      {
        id:engagements[index - 1].id,
        ordinal:engagements[index].ordinal,
        campaignId:engagements[index - 1].campaignId
      }
    ])
      .catch((err) => this.setState({error:err}));
  }

  handleChooseSubmit(data){
    const {
      updateEngagement,
      syncEngagementDCMTags,
      updateEngagmentOptions
    } = this.props;

    Promise.all([
      updateEngagement(data.id,omit(data,['id','tags','options'])),
      this.adjustAndSyncTags(syncEngagementDCMTags, data.id, data.tags)
    ])
      .then(() => updateEngagmentOptions(data.id,data.options))
      .catch((err) => this.setState({error:err}));

    this.setState({activeSection:null});
  }

  handleThisOrThatSubmit(data){
    const {
      updateEngagement,
      syncEngagementDCMTags
    } = this.props;

    Promise.all([
      updateEngagement(data.id,omit(data,['id','tags'])),
      this.adjustAndSyncTags(syncEngagementDCMTags, data.id, data.tags)
    ])
      .catch((err) => this.setState({error:err}));

    this.setState({activeSection:null});
  }

  handleQASubmit(data){
    const {
      updateEngagement,
      syncEngagementDCMTags,
      updateEngagmentOptions
    } = this.props;

    Promise.all([
      updateEngagement(data.id,omit(data,['id','tags','options'])),
      this.adjustAndSyncTags(syncEngagementDCMTags, data.id, data.tags)
    ])
      .then(() => updateEngagmentOptions(data.id,data.options))
      .catch((err) => this.setState({error:err}));

    this.setState({activeSection:null});
  }


  handlePuzzleSubmit(data){
    const {
      updateEngagement,
      syncEngagementDCMTags
    } = this.props;

    Promise.all([
      updateEngagement(data.id,omit(data,['id','tags','options'])),
      this.adjustAndSyncTags(syncEngagementDCMTags, data.id, data.tags)
    ])
      .catch((err) => this.setState({error:err}));

    this.setState({activeSection:null});
  }

  handleRatableSubmit(data){
    const {
      updateEngagement,
      syncEngagementDCMTags,
      updateEngagmentOptions
    } = this.props;

    Promise.all([
      updateEngagement(data.id,omit(data,['id','tags'])),
      this.adjustAndSyncTags(syncEngagementDCMTags, data.id, data.tags)
    ])
      .catch((err) => this.setState({error:err}));

    this.setState({activeSection:null});
  }

  handleConclusionSubmit(data, isValid){
    const feedTags = (this.props.activeCampaign.tags||[]).filter((t) => t.type === 'feed'),
      conclusionTags = data.tags || [];

    this.handleCampaignChange({
      completionText:data.completionText,
      completionImageURL:data.completionImageURL,
      completionImageFileName:data.completionImageFileName,
      ctaBrowser: data.ctaBrowser,
      useCTA:data.useCTA,
      useAppLink: data.useAppLink,
      ctaLink:data.ctaLink || '',
      iosLink:data.iosLink || '',
      androidLink:data.androidLink || '',
      ctaText:data.ctaText || '',
      ctaColor:data.ctaColor || '',
    });
    // this.props.syncCampaignDCMTags(this.props.campaignId,conclusionTags.concat(feedTags));
    this.setState({activeSection: null});
  }

  handleEngagementDeleteClick(index){
    const { activeEngagements, deleteEngagement } = this.props;

    let newActivePreviewEngagementId;

    if(index === 0){
      newActivePreviewEngagementId = FEED_PREVIEW_ID;
    } else {
      newActivePreviewEngagementId = activeEngagements[index - 1].id;
    }

    deleteEngagement(activeEngagements[index].id);

    this.setState({
      activeSection:null,
      activePreviewEngagementId:newActivePreviewEngagementId
    });
  }

  handleScroll(top){
    if(top > (NAVBAR_HEIGHT - 10) && !this.state.previewIsFixed){
      this.setState({previewIsFixed:true});
    }

    if(top <= (NAVBAR_HEIGHT - 10) && this.state.previewIsFixed){
      this.setState({previewIsFixed:false})
    }
  }

  handleSubmitClick(){
    if(this.props.isOnboarding){
      this.props.updateUser(this.props.activeUser.id,{hasSeenCampaignIntro:true})
        .then(() => this.props.history.push(`/welcome/tutorial/${this.props.activeCampaign.id}/audience`))
        .catch((err) => this.setState({error:err}));

    } else {
      this.props.updateUser(this.props.activeUser.id,{hasSeenCampaignIntro:true})
        .then(() => this.props.history.push(this.props.forwardURL))
        .catch((err) => this.setState({error:err}));
    }
  }

  handleSaveDraftClick(){
    if(this.props.backURL){
      this.props.history.push(this.props.backURL);
    } else if(this.props.showSuperadminFeatures){
      this.props.history.push('/superadmin/experiences');
    } else if(this.props.isOnboarding){
      this.props.history.push('/account/experiences');
    } else {
      this.props.history.push('/account/experiences');
    }
  }

  showQAToggle(){
    const activeEngagement = find(this.props.activeEngagements,(e) => e.id === this.state.activePreviewEngagementId)

    return activeEngagement && activeEngagement.kind === 'qa'
  }

  adjustAndSyncTags(syncTags, id, tags){
    const vendors = this.props.tagVendors
    const adjustedTags = tags.map((tag) => {
      const vendor = vendors[tag.vendorId]
      if (vendor.verify){
        return {id: tag.id, type: tag.type, vendorId: tag.vendorId, parameters: tag.tag}
      }
      return {id: tag.id, type: tag.type, vendorId: tag.vendorId, tag: tag.tag}
    })
    syncTags(id, adjustedTags)
  }

  render(){
    const {
      activeSection,
      isLoading,
      isCreatingEngagement,
      activePreviewEngagementId,
      previewIsFixed,
      brandIsValid,
      showQAAnswer,
      activeProgram,
        isProgramValid
    } = this.state;

    const {
      match,
      isCreate,
      agencies,
      brands,
      activeAgency,
      activeCampaign,
      activeBrand,
      activeEngagements,
      activeUserHasSeenTutorial,
      addOptionToEngagement,
      deleteEngagementOption,
      invalidEngagementIndexes,
      allRequiredFieldsAreFilled,
      allowingBrandEditingInline,
      isOnboarding,
      showSuperadminFeatures,
      isCampaignEditable,
      isBudgetLocked,
      missingFields,
      activeAgencyAccountingBalance,
        programs,
      preSelectedBrand,
      preSelectedAgency
    } = this.props;

    const previewHeight = getWindowHeight() - 300;

    if(isLoading && isOnboarding){
      return (
        <TutorialLoadingScreen
          title="Let's build an experience together!"
          subtitle=''
          showSpinner
        />
      )
    }

    if(isLoading && !isOnboarding){
      return (
        <div>Loading<ProgressEllipses /></div>
      )
    }

    return (
      <div className='GuidedCampaignCreation'>
        <ScrollWatcher onScroll={(top) => this.handleScroll(top)} />
        <Row>
          <Col xs='8'>
            <br />
            <h3>Create your experience</h3>
            <p>Engage and learn from consumers.</p>
            <Row>
              <Col md='12' lg='8'>
                <br />
                <h5>About the experience</h5>
                {showSuperadminFeatures && (
                  <CollapsingSection
                    open={activeSection ===  AGENCY_SECTION}
                    onOpenClick={() => this.setState({activeSection:AGENCY_SECTION})}
                    title='Account'
                    subtitle={activeAgency.name || preSelectedAgency.name}
                    locked={(activeCampaign.companyId && activeCampaign.companyId.length > 0) || !isCampaignEditable}
                    titleWidthInColumns={4}
                  >
                    <CampaignAgencyForm
                      open={activeSection ===  AGENCY_SECTION}
                      activeAgencyId={activeAgency.id || preSelectedAgency.id}
                      possibleAgencies={agencies}
                      onSubmit={(data) => this.handleAgencySubmit(data)}
                      isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                      canCreateNew={!preSelectedAgency.id}
                    />
                  </CollapsingSection>
                )}
                <CollapsingSection
                  open={activeSection === NAME_SECTION}
                  onOpenClick={() => this.setState({activeSection:NAME_SECTION})}
                  title={activeSection === NAME_SECTION ? 'Name for reporting':'Name'}
                  subtitle={activeCampaign.name}
                  locked={!isCampaignEditable || (!activeCampaign.agencyId && showSuperadminFeatures)}
                  valid={!!(activeCampaign.name && activeCampaign.name.length > 0)}
                  titleWidthInColumns={4}
                >
                  <CampaignNameForm
                    open={activeSection === NAME_SECTION}
                    activeCampaignName={activeCampaign.name}
                    onSubmit={(data) => this.handleNameSubmit(data)}
                    isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                  />
                </CollapsingSection>
                <CollapsingSection
                  open={activeSection === BUDGET_SECTION}
                  onOpenClick={() => this.setState({activeSection:BUDGET_SECTION})}
                  title='Threshold'
                  subtitle={activeCampaign.lifetimeBudget >= 50 ? (<MoneyDisplay>{activeCampaign.lifetimeBudget}</MoneyDisplay>) : 'none'}
                  locked={!isCampaignEditable || (isBudgetLocked && !showSuperadminFeatures) || !activeCampaign.agencyId}
                  valid={!!(activeCampaign.lifetimeBudget && activeCampaign.lifetimeBudget >= 50)}
                  titleWidthInColumns={4}
                >
                  <CampaignBudgetForm
                    open={activeSection === BUDGET_SECTION}
                    activeCampaignAgencyId={activeCampaign.agencyId}
                    activeCampaignBudget={activeCampaign.lifetimeBudget}
                    activeCampaignRevenueSplit={activeCampaign.revenueSplit}
                    activeCampaignCostPerCompletion={activeCampaign.costPerCompletion}
                    activeCampaignUseCostPerCompletion={activeCampaign.useCostPerCompletion}
                    currentURLForRedirect={match.url}
                    availableBudget={activeAgencyAccountingBalance}
                    onSubmit={(data) => this.handleBudgetSubmit(data)}
                    isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                    showSuperadminFeatures={showSuperadminFeatures}
                    isOnboarding={isOnboarding}
                  />
                </CollapsingSection>
                <CollapsingSection
                  open={activeSection === START_DATE_SECTION}
                  onOpenClick={() => this.setState({activeSection:START_DATE_SECTION})}
                  title={activeSection === START_DATE_SECTION ? (<ExpandedStartDateTitle />) : 'Start date'}
                  subtitle={formatDateRange(activeCampaign.launchDate,activeCampaign.endDate,'to')}
                  locked={!isCampaignEditable || !activeCampaign.agencyId}
                  valid={!!activeCampaign.launchDate}
                  titleWidthInColumns={4}
                >
                  <CampaignStartDateForm
                    open={activeSection === START_DATE_SECTION}
                    activeCampaignLaunchDate={activeCampaign.launchDate}
                    activeCampaignEndDate={activeCampaign.endDate}
                    onSubmit={(data) => this.handleDateSubmit(data)}
                    isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                  />
                </CollapsingSection>
                <CollapsingSection
                  open={activeSection === BRAND_SECTION}
                  onOpenClick={() => this.setState({activeSection:BRAND_SECTION})}
                  title='Brand'
                  subtitle={activeBrand.name || preSelectedBrand.name}
                  locked={(!allowingBrandEditingInline && activeEngagements.length > 0) || !isCampaignEditable || !activeCampaign.agencyId}
                  valid={!!(activeCampaign.companyId && activeCampaign.companyId.length > 0 && activeBrand.primaryColor && activeBrand.primaryColor.length > 0 && activeBrand.logoURL && activeBrand.logoURL.length > 0)}
                  titleWidthInColumns={4}
                >
                  <CampaignBrandForm
                    open={activeSection === BRAND_SECTION}
                    allowingBrandEditingInline={allowingBrandEditingInline}
                    activeBrandId={activeCampaign.companyId || preSelectedBrand.id}
                    possibleBrands={brands}
                    onSubmit={(data) => this.handleBrandSubmit(data)}
                    isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                    canCreateNew={!preSelectedBrand.id}
                  />
                </CollapsingSection>
                {isEmptyObject(this.props.activeUser) &&
                    <CollapsingSection
                      open={activeSection === PRIORITY_SECTION}
                      onOpenClick={() => this.setState({activeSection:PRIORITY_SECTION})}
                      title='Priority'
                      subtitle={(Number(activeCampaign.priority) === 9 || !activeCampaign.priority) ? 'Default' : String(activeCampaign.priority)}
                      locked={!isCampaignEditable || !activeCampaign.agencyId}
                      valid={true}
                      titleWidthInColumns={4}
                    >
                      <CampaignPriorityForm
                        open={activeSection === PRIORITY_SECTION}
                        priority={Number(activeCampaign.priority) || 9}
                        onSubmit={(data) => this.handlePrioritySubmit(data)}
                        isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                      />
                    </CollapsingSection>
                }
                <CollapsingSection
                    open={activeSection === PROGRAM_SECTION}
                    onOpenClick={() => this.setState({activeSection:PROGRAM_SECTION})}
                    title='Program'
                    subtitle={activeProgram ? `${activeProgram.name} (${moment.utc(activeProgram.startDate).format('MM/DD/YYYY')}-${moment.utc(activeProgram.endDate).format('MM/DD/YYYY')}) - $${activeProgram.cardAmount}` : ''}
                    locked={!isCampaignEditable || !activeCampaign.agencyId}
                    valid={!!this.state.isProgramValid}
                    titleWidthInColumns={4}
                >
                  <CampaignProgramForm
                      open={activeSection === PROGRAM_SECTION}
                      activeCampaign={activeCampaign}
                      programs={programs}
                      isValidRange={!!isProgramValid}
                      onSubmit={(data) => this.handleProgramSubmit(data)}
                      isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                  />
                </CollapsingSection>
              </Col>
            </Row>
            <Row>
              <Col xs='12'>
                <br />
                <h5>What will consumers see first?</h5>
                <CollapsingSection
                  open={activeSection === COVER_SECTION}
                  onOpenClick={() => this.setState({
                    activeSection:COVER_SECTION,
                    activePreviewEngagementId:FEED_PREVIEW_ID
                  })}
                  title='Cover Tile'
                  subtitle={cutOffLongTextIfNeeded(activeCampaign.feedText || '',50)}
                  locked={!isCampaignEditable || !activeCampaign.agencyId}
                  valid={isCoverValid(activeCampaign)}
                  showBoxShadow
                >
                  <CampaignCoverForm
                    open={activeSection === COVER_SECTION}
                    activeCampaignFeedText={activeCampaign.feedText || ''}
                    activeCampaignFeedImageURL={activeCampaign.feedImageURL}
                    activeCampaignFeedImageFileName={activeCampaign.feedImageFileName}
                    activeCampaignFeedTags={(activeCampaign.tags || []).filter((t) =>t.type === 'feed')}
                    onSubmit={(data) => this.handleCoverSubmit(data)}
                    isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                    showSuperadminFeatures={showSuperadminFeatures}
                  />
                </CollapsingSection>
              </Col>
            </Row>
            <Row>
              <Col xs='12'>
                <br />
                <br />
                <h5>Your experience</h5>
                <p>Add one or more activity cards to build your experience.</p>
                {activeEngagements.map((e,index) => (
                  <div key={e.id}>
                    {e.kind === CHOOSE_ENGAGEMENT_TYPE && (
                      <CollapsingSection
                        open={activeSection === e.id}
                        onOpenClick={() => this.setState({
                          activeSection:e.id,
                          activePreviewEngagementId:e.id
                        })}
                        title={(
                          <EngagementTitle
                            icon={ChooseEngagementSVG}
                            text={`${index + 1}. Multiple Choice`}
                            expanded={activeSection === e.id}
                            onPromoteClick={() => this.handlePromoteClick(index)}
                            onDemoteClick={() => this.handleDemoteClick(index)}
                            onDeleteClick={() => this.handleEngagementDeleteClick(index)}
                          />
                        )}
                        subtitle={cutOffLongTextIfNeeded(e.text,50)}
                        locked={(activeCampaign.companyId === null) || !isCampaignEditable}
                        valid={isEngagementValid(e)}
                        showBoxShadow
                      >
                        <CampaignChooseForm
                          open={activeSection === e.id}
                          engagement={e}
                          activeEngagementId={e.id}
                          activeEngagementText={e.text}
                          activeEngagementImageURL={e.firstImageURL}
                          activeEngagementImageFileName={e.firstImageFileName}
                          activeEngagementImageId={e.firstImageId}
                          activeEngagementOptions={e.options}
                          activeEngagementFirstTags={(e.tags || []).filter((t) => t.type === 'first')}
                          showResults={e.showResults === true }
                          onAddChoiceClick={() => addOptionToEngagement(e.id)}
                          onDeleteChoiceClick={(id) => deleteEngagementOption(e.id,id)}
                          onSubmit={(data) => this.handleChooseSubmit(data)}
                          isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                          showSuperadminFeatures={showSuperadminFeatures}
                        />
                      </CollapsingSection>
                    )}
                    {e.kind === THIS_OR_THAT_ENGAGEMENT_TYPE && (
                      <CollapsingSection
                        open={activeSection === e.id}
                        onOpenClick={() => this.setState({
                          activeSection:e.id,
                          activePreviewEngagementId:e.id
                        })}
                        title={(
                          <EngagementTitle
                            open={activeSection === e.id}
                            icon={ThisOrThatEngagementSVG}
                            text={`${index + 1}. This or That`}
                            expanded={activeSection === e.id}
                            onPromoteClick={() => this.handlePromoteClick(index)}
                            onDemoteClick={() => this.handleDemoteClick(index)}
                            onDeleteClick={() => this.handleEngagementDeleteClick(index)}
                          />
                        )}
                        subtitle={(e.firstImageTitle && e.secondImageTitle) ? `${e.firstImageTitle} or ${e.secondImageTitle}?` : ''}
                        locked={(activeCampaign.companyId === null) || !isCampaignEditable}
                        valid={isEngagementValid(e)}
                        showBoxShadow
                      >
                        <CampaignThisOrThatForm
                          open={activeSection === e.id}
                          engagement={e}
                          activeEngagementId={e.id}
                          activeEngagementFirstImageURL={e.firstImageURL}
                          activeEngagementFirstImageFileName={e.firstImageFileName}
                          activeEngagementFirstImageId={e.firstImageId}
                          activeEngagementFirstImageTitle={e.firstImageTitle}
                          activeEngagementSecondImageURL={e.secondImageURL}
                          activeEngagementSecondImageFileName={e.secondImageFileName}
                          activeEngagementSecondImageId={e.secondImageId}
                          activeEngagementSecondImageTitle={e.secondImageTitle}
                          activeEngagementDCMTag={e.dcmTag}
                          activeEngagementFirstTags={(e.tags || []).filter((t) => t.type === 'first')}
                          activeEngagementSecondTags={(e.tags || []).filter((t) => t.type === 'second')}
                          activeEngagementSecondDCMTag={e.secondDcmTag}
                          showOverlay={e.showOverlay !== false }
                          showResults={e.showResults === true }
                          onSubmit={(data) => this.handleThisOrThatSubmit(data)}
                          isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                        />
                      </CollapsingSection>
                    )}
                    {e.kind === RATABLE_ENGAGEMENT_TYPE && (
                      <CollapsingSection
                        open={activeSection === e.id}
                        onOpenClick={() => this.setState({
                          activeSection:e.id,
                          activePreviewEngagementId:e.id
                        })}
                        title={(
                          <EngagementTitle
                            icon={VideoEngagementSVG}
                            text={`${index+1}. Video`}
                            expanded={activeSection === e.id}
                            onPromoteClick={() => this.handlePromoteClick(index)}
                            onDemoteClick={() => this.handleDemoteClick(index)}
                            onDeleteClick={() => this.handleEngagementDeleteClick(index)}
                          />
                        )}
                        subtitle={e.text.length > 0 ? cutOffLongTextIfNeeded(e.text,50) : ''}
                        locked={(activeCampaign.companyId === null) || !isCampaignEditable}
                        valid={isEngagementValid(e)}
                        showBoxShadow
                      >
                        <CampaignRatableForm
                          open={activeSection === e.id}
                          engagement={e}
                          activeEngagementId={e.id}
                          activeEngagementText={e.text}
                          activeEngagementVideoURL={e.videoURL}
                          activeEngagementVideoFileName={e.videoFileName}
                          activeEngagementVideoId={e.videoId}
                          activeEngagementFirstTags={(e.tags || []).filter((t) => t.type === 'first')}
                          onSubmit={(data) => this.handleRatableSubmit(data)}
                          isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                        />
                      </CollapsingSection>
                    )}
                    {e.kind === QA_ENGAGEMENT_TYPE && (
                      <CollapsingSection
                        open={activeSection === e.id}
                        onOpenClick={() => this.setState({
                          activeSection:e.id,
                          activePreviewEngagementId:e.id
                        })}
                        title={(
                          <EngagementTitle
                            icon={QAEngagementSVG}
                            text={`${index+1}. Trivia`}
                            expanded={activeSection === e.id}
                            onPromoteClick={() => this.handlePromoteClick(index)}
                            onDemoteClick={() => this.handleDemoteClick(index)}
                            onDeleteClick={() => this.handleEngagementDeleteClick(index)}
                          />
                        )}
                        subtitle={e.text.length > 0 ? cutOffLongTextIfNeeded(e.text,50) : ''}
                        locked={(activeCampaign.companyId === null) || !isCampaignEditable}
                        valid={isEngagementValid(e)}
                        showBoxShadow
                      >
                        <CampaignQAForm
                          open={activeSection === e.id}
                          engagement={e}
                          activeEngagementId={e.id}
                          activeEngagementText={e.text}
                          activeEngagementFirstImageURL={e.firstImageURL}
                          activeEngagementFirstImageFileName={e.firstImageFileName}
                          activeEngagementFirstImageId={e.firstImageId}
                          activeEngagementSecondImageURL={e.secondImageURL}
                          activeEngagementSecondImageFileName={e.secondImageFileName}
                          activeEngagementSecondImageId={e.secondImageId}
                          activeEngagementOptions={e.options}
                          activeEngagementCorrectAnswerText={e.correctAnswerText}
                          activeEngagementCorrectAnswerId={e.correctAnswerId}
                          activeEngagementDCMTag={e.dcmTag}
                          activeEngagementFirstTags={(e.tags || []).filter((t) => t.type === 'first')}
                          activeEngagementSecondTags={(e.tags || []).filter((t) => t.type === 'second')}
                          onAddChoiceClick={() => addOptionToEngagement(e.id)}
                          onDeleteChoiceClick={(id) => deleteEngagementOption(e.id,id)}
                          onSubmit={(data) => this.handleQASubmit(data)}
                          isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                          showSuperadminFeatures={showSuperadminFeatures}
                        />
                      </CollapsingSection>
                    )}
                    {e.kind === PUZZLE_ENGAGEMENT_TYPE && (
                      <CollapsingSection
                        open={activeSection === e.id}
                        onOpenClick={() => this.setState({
                          activeSection:e.id,
                          activePreviewEngagementId:e.id
                        })}
                        title={(
                          <EngagementTitle
                            icon={PuzzleEngagementSVG}
                            text={`${index + 1}. Puzzle`}
                            expanded={activeSection === e.id}
                            onPromoteClick={() => this.handlePromoteClick(index)}
                            onDemoteClick={() => this.handleDemoteClick(index)}
                            onDeleteClick={() => this.handleEngagementDeleteClick(index)}
                          />
                        )}
                        subtitle={cutOffLongTextIfNeeded(e.text,50)}
                        locked={(activeCampaign.companyId === null) || !isCampaignEditable}
                        valid={isEngagementValid(e)}
                        showBoxShadow
                      >
                        <CampaignPuzzleForm
                          open={activeSection === e.id}
                          engagement={e}
                          activeEngagementId={e.id}
                          activeEngagementText={e.text}
                          activeEngagementImageURL={e.firstImageURL}
                          activeEngagementImageFileName={e.firstImageFileName}
                          activeEngagementImageId={e.firstImageId}
                          activeEngagementFirstTags={(e.tags || []).filter((t) => t.type === 'first')}
                          onSubmit={(data) => this.handlePuzzleSubmit(data)}
                          isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                          showSuperadminFeatures={showSuperadminFeatures}
                        />
                      </CollapsingSection>
                    )}
                  </div>
                ))}
              </Col>
            </Row>
            <Row>
              <Col xs='12'>
                <br />
                <h5>{isCreatingEngagement ? (<span>Adding your activity<ProgressEllipses /></span>): 'Add an activity'}</h5>
                <CreateEngagementButtons
                  disabled={isCreatingEngagement || isCreate || !activeCampaign.companyId || !isCampaignEditable|| !activeCampaign.agencyId}
                  onClick={(kind) => this.handleAddEngagementClick(kind)}
                />
                {invalidEngagementIndexes.length > 0 && (
                  <FormText className='DangerFeedback'>
                    {formatIncompleteEngagements(invalidEngagementIndexes)}
                  </FormText>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs='12'>
                <br />
                <br />
                <h5>How will you end the experience?</h5>
                <CollapsingSection
                  open={activeSection === CONCLUSION_SECTION}
                  onOpenClick={() => this.setState({
                    activeSection:CONCLUSION_SECTION,
                    activePreviewEngagementId:CONCLUSION_PREVIEW_ID
                  })}
                  title='Conclusion'
                  subtitle={cutOffLongTextIfNeeded((activeCampaign.completionText || '').replace(/<\/?[^>]+(>|$)/g, ""),50)}
                  locked={!isCampaignEditable || !activeCampaign.agencyId}
                  valid={isConclusionValid(activeCampaign)}
                  titleWidthInColumns={3}
                  showBoxShadow
                >
                  <CampaignConclusionForm
                    open={activeSection === CONCLUSION_SECTION}
                    activeCampaignCompletionText={activeCampaign.completionText}
                    activeCampaignUseCTA={activeCampaign.useCTA}
                    activeCampaignUseAppLink={activeCampaign.useAppLink}
                    activeCampaignCTAText={activeCampaign.ctaText}
                    activeCampaignCTALink={activeCampaign.ctaLink}
                    activeCampaignIOSLink={activeCampaign.iosLink}
                    activeCampaignAndroidLink={activeCampaign.androidLink}
                    activeCampaignCTAColor={activeCampaign.ctaColor || activeBrand.primaryColor}
                    activeCampaignConclusionTags={(activeCampaign.tags || []).filter((t) =>t.type === 'conclusion')}
                    activeCampaignCompletionImageURL={activeCampaign.completionImageURL}
                    activeCampaignCompletionFileName={activeCampaign.completionImageFileName}
                    activeCampaignCtaBrowser={activeCampaign.ctaBrowser}
                    onSubmit={(data, isValid) => this.handleConclusionSubmit(data, isValid)}
                    isShowingTutorial={isOnboarding || !activeUserHasSeenTutorial}
                  />
                </CollapsingSection>
              </Col>
            </Row>
            <Row>
              <Col md='12' lg='8'>
                <br />
                <p>
                  Happy with your experience?  Add payment and launch it!  Have questions?&nbsp;&nbsp;
                  <a href='mailto:campaignhelp@getdabbl.com'>Ask us</a>.
                </p>
                {missingFields.length > 0 && (
                  <div>
                    <FormText className='DangerFeedback'>
                      {humanReadableList(missingFields)} {missingFields.length === 1 ? 'is' : 'are'} invalid.
                    </FormText>
                    <br />
                  </div>
                )}
                <Button
                  color="primary"
                  disabled={invalidEngagementIndexes.length > 0 || !allRequiredFieldsAreFilled || !isCampaignEditable || !brandIsValid || activeEngagements.length < MINIMUM_NUMBER_OF_ENGAGEMENTS || !isProgramValid}
                  onClick={() => this.handleSubmitClick()}
                >
                  &nbsp;&nbsp;Next: Audience&nbsp;&nbsp;
                </Button>
                &nbsp;&nbsp;
                <Button onClick={() => this.handleSaveDraftClick()}>
                  Save for later
                </Button>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </Col>
            </Row>
          </Col>
          <Col xs={{size:4}}>
            <div
              style={{
                position:previewIsFixed ? 'fixed' : 'inherit',
                top:previewIsFixed ? 10 : 0,
                paddingTop:10,
                width:300
              }}
            >
              <PhonePreview
                hideTotalValue
                phonePlatform='generic'
                activeEngagementId={activePreviewEngagementId}
                engagements={activeEngagements.map((e) => engagementOrDefaults(e))}
                feedText={activeCampaign.feedText || ''}
                feedImageURL={activeCampaign.feedImageURL || Placeholder1x1}
                height={previewHeight > MAXIMUM_PREVIEW_HEIGHT ? MAXIMUM_PREVIEW_HEIGHT : previewHeight}
                brandName={activeBrand.name}
                logoURL={activeBrand.logoURL || Placeholder1x1}
                conclusionText={activeCampaign.completionText || 'Thanks for spending time with us'}
                conclusionBackgroundColor={activeBrand.primaryColor}
                completionImageURL={activeCampaign.completionImageURL || Placeholder4x3}
                showQAAnswer={showQAAnswer}
                cta={activeCampaign.useCTA ? {link: activeCampaign.ctaLink, color: activeCampaign.ctaColor || '#ffffff', text: activeCampaign.ctaText|| 'Visit our Site'} : null}
              />
              {this.showQAToggle() ? (
                <div>
                  <Pills
                    center
                    states={['question','answer']}
                    selected={showQAAnswer ? 'answer' : 'question'}
                    onChange={(selected) => this.setState({showQAAnswer:selected === 'answer'})}
                  />
                </div>
              ) : (
                <br />
              )}
              <br />
              <CampaignOverview
                activeCampaign={activeCampaign}
                activeEngagements={activeEngagements}
              />
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

GuidedCampaignCreation.defaultProps={
  isOnboarding:false,
  allowingBrandEditingInline:false
}

export default GuidedCampaignCreation;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/GuidedCampaignCreation.js